import { Button } from "@mui/material";
import { AddIcon } from "./add";

type Props = {
	onClick: () => void;
	variant?: string;
};

export const AddButton = ({ onClick, variant = "contained" }: Props) => {
	return (
		<Button
			fullWidth
			variant={variant as "text" | "outlined" | "contained" | undefined}
			color="primary"
			onClick={onClick}
			aria-label="add"
			style={{
				width: "auto",
				height: 35,
				display: "flex",
				justifyContent: "space-between",
				padding: "0 14px",
				fontSize: 14,
			}}
		>
			<div style={{ margin: "0 12px 4px 0" }}>
				<AddIcon color={"#FFF"} />
			</div>
			ADD
		</Button>
	);
};
